// tslint:disable-next-line:no-namespace
module ProcessList {
    "use strict";
    import IModalInstance = angular.ui.bootstrap.IModalServiceInstance;
    export class LogSettingsModalController {
        public static $inject = ["$uibModalInstance", "processNames", "logLevel", "retentionDays", "logTriggerData"];
        public headerText: string;
        public showEnvironmentLogSettingsOverride: boolean = false;
        public overrideEnvironmentLogSettings: boolean = false;

        constructor(
            private $modalInstance: IModalInstance,
            private processNames: string[],
            private logLevel: string,
            private retentionDays: number,
            private logTriggerData: boolean) {

            if (!processNames || processNames.length === 0) {
                // environment-level settings
                this.headerText = FRENDS.Localizations.LogSettingsForEnvironment;
            } else {
                this.showEnvironmentLogSettingsOverride = true;
                if (processNames.length === 1) {
                    this.headerText = FRENDS.Localizations.LogSettingsForProcess + " " + processNames[0];
                    // if loglevel or retention days is set, we have already overridden the values
                    this.overrideEnvironmentLogSettings = !!this.logLevel || !!this.retentionDays;
                } else {
                    this.headerText = FRENDS.Localizations.LogSettingsForSelectedProcesses;
                }
            }

            // defaults
            this.logLevel = logLevel || "Info";
            this.retentionDays = retentionDays || 60;
            this.logTriggerData = logTriggerData || false;
        }

        public get controlsDisabled() {
            return this.showEnvironmentLogSettingsOverride && !this.overrideEnvironmentLogSettings;
        }

        public confirm() {
            const result: LogSettingsModalResult = {
                overrideEnvironmentLogSettings: this.overrideEnvironmentLogSettings,
                logLevel: this.logLevel,
                retentionDays: this.retentionDays,
                logTriggerData: this.logTriggerData
            };
            this.$modalInstance.close(result);
        }

        public cancel() {
            this.$modalInstance.dismiss();
        }
    }

    module.controller("LogSettingsModalController", LogSettingsModalController);

    export interface LogSettingsModalResult {
        overrideEnvironmentLogSettings: boolean;
        logLevel: string;
        retentionDays: number;
        logTriggerData: boolean;
    }
}
